// Google Analytics 4: caricato solo se l'admin ha impostato l'ID in Info Negozio (ga_measurement_id)
let gaId = null;

export const initGA = (id) => {
  if (!id || !/^G-[A-Z0-9]+$/i.test(id) || gaId) return;
  gaId = id;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { send_page_view: false, anonymize_ip: true });
};

export const trackPageView = (path) => { if (gaId) window.gtag("event", "page_view", { page_path: path, page_location: window.location.href, page_title: document.title }); };

export const trackEvent = (name, params = {}) => { if (gaId) window.gtag("event", name, params); };

const item = (p, qty = 1, price) => ({ item_id: p.product_id, item_name: p.name, item_brand: p.brand, item_category: p.category, price: Number(price ?? p.price), quantity: qty });

export const gaViewItem = (p) => trackEvent("view_item", { currency: "EUR", value: Number(p.price), items: [item(p)] });
export const gaAddToCart = (p, qty = 1) => trackEvent("add_to_cart", { currency: "EUR", value: Number(p.price) * qty, items: [item(p, qty)] });
export const gaBeginCheckout = (items, value) => trackEvent("begin_checkout", { currency: "EUR", value, items: items.map((i) => item(i, i.quantity)) });
export const gaPurchase = (order) => trackEvent("purchase", {
  transaction_id: order.order_id, currency: "EUR", value: Number(order.total), shipping: Number(order.shipping_cost || 0),
  coupon: order.discount_code || undefined, items: (order.items || []).map((i) => ({ item_id: i.product_id, item_name: i.name, price: Number(i.price), quantity: i.quantity })),
});
